import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { User } from 'src/app/model/user.model';
import { BehaviorSubject } from 'rxjs';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})

export class ExcelService {

  excelDownloadData: any = [];
  // userArray:any=[];
  userListExcelDownload: User[] = [];
  // branchName: any;
  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array'} );
    this.saveAsExcelFile(excelBuffer, excelFileName);

  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});

    FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
  }

  downloadExcelFile(values: any, fileName: any) {

    // const fileName: any = this.data.institutionName + '-' + name;
    this.userListExcelDownload = values;

    if (values === null) {
      const excelDownloadModel: any = new class {
        'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
        'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''
      };

      excelDownloadModel['S.NO'] = '';
      excelDownloadModel['Full Name'] = '';
      excelDownloadModel['Phone Number'] = '';
      excelDownloadModel['Gender'] = '';
      excelDownloadModel['Email id'] = '';
      excelDownloadModel['Qualification'] = '';
      excelDownloadModel['Year Of Passing'] = '';
      excelDownloadModel['Registered Date'] = '';
      excelDownloadModel['Permanent Pin Code'] = '';
      excelDownloadModel['Current Pin Code'] = '';
      this.excelDownloadData.push(excelDownloadModel);
      this.exportAsExcelFile(this.excelDownloadData, fileName);
    } else {

      let rowNumber: number = 0;

      for (const response of this.userListExcelDownload) {
        const excelDownloadModel: any = new class {
          'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
          'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''
        };
        excelDownloadModel['S.NO'] = ++rowNumber;
        excelDownloadModel['Full Name'] = response.fullName;
        excelDownloadModel['Phone Number'] = response.phoneNumber;
        excelDownloadModel['Gender'] = response.gender;
        excelDownloadModel['Email id'] = response.emailId;
        excelDownloadModel['Qualification'] = response.qualification;
        excelDownloadModel['Year Of Passing'] = response.graduationYear;
        excelDownloadModel['Registered Date'] = response.registeredDate;
        excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
        excelDownloadModel['Current Pin Code'] = response.currentPinCode;
        this.excelDownloadData.push(excelDownloadModel);
      }
      this.exportAsExcelFile(this.excelDownloadData, fileName);
    }
    this.excelDownloadData = [];
  }

}
